import apiClient from './api'

const authService = {
  async login(credentials) {
    try {
      const response = await apiClient.post('/admin/login', credentials)
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async logout() {
    try {
      await apiClient.post('/admin/logout')
    } catch (error) {
      // Even if logout fails on server, we still clear local data
      console.error('Logout error:', error)
    }
  },

  async refreshToken() {
    try {
      const response = await apiClient.post('/admin/refresh-token')
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  },

  async getProfile() {
    try {
      const response = await apiClient.get('/admin/profile')
      return response.data
    } catch (error) {
      throw error.response?.data || error
    }
  }
}

export default authService 